import { Col, Dropdown, Input, Row, Text } from 'components';

export const statusOptions = [
  {
    value: 'All'
  },
  {
    value: 'Pending approval'
  }
];

export const dummyOptions = [{ value: 'All' }, { value: 'Yes' }, { value: 'No' }];

export const bannedOptions = [{ value: 'All' }, { value: 'Yes' }, { value: 'No' }];

export const sportOptions = [
  {
    value: 'All'
  },
  {
    value: 'Soccer',
    opt: 'soccer'
  },
  {
    value: 'Basketball',
    opt: 'basketball'
  },
  {
    value: 'Baseball',
    opt: 'baseball'
  },
  {
    value: 'American Football',
    opt: 'americanFootball'
  }
];

const Filters = ({
  type,
  setType,
  text,
  setText,
  dummy,
  setDummy,
  banned,
  setBanned,
  sport,
  setSport
}) => {
  return (
    <Row start gap="30px" pad="12px 0" noFlex>
      <Col noFlex>
        <Text marg="0 40px 4px" b2 med>
          Filter by team
        </Text>

        <Input
          big
          search
          pad="0 24px"
          wid="427px"
          placeholder="Search teams..."
          value={text}
          onChange={({ target }) => setText(target.value)}
        />
      </Col>

      <Dropdown
        admin
        title="Status"
        wid="300px"
        selected={type}
        options={statusOptions}
        handleSelect={setType}
        rounded
        small
      />

      <Dropdown
        admin
        title="Dummy"
        wid="150px"
        selected={dummy}
        options={dummyOptions}
        handleSelect={setDummy}
        rounded
        small
      />

      <Dropdown
        admin
        title="Banned"
        wid="150px"
        selected={banned}
        options={bannedOptions}
        handleSelect={setBanned}
        rounded
        small
      />

      <Dropdown
        admin
        title="Sport"
        wid="300px"
        selected={sport}
        options={sportOptions}
        handleSelect={setSport}
        rounded
        small
      />
    </Row>
  );
};

export default Filters;
